import { useConditionFieldSelect } from '../../hooks/useConditionFieldSelect';
import { useEditorActions } from '../../hooks/useEditorActions';
import EditorConditionFieldOptions from './EditorConditionFieldOptions';
import EditorFilterSelectBreadcrumbs from './EditorFilterSelectBreadcrumbs';
import EditorTitle from './EditorTitle';
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UISearchInput from 'UIComponents/input/UISearchInput';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionFieldSelectPanelContainer = styled.div.withConfig({
  displayName: "EditorConditionFieldSelectPanel__EditorConditionFieldSelectPanelContainer",
  componentId: "nmsvvi-0"
})(["display:flex;flex-direction:column;height:100%;width:400px;"]);
const EditorConditionFieldSelectPanel = ({
  filterFamily
}) => {
  const {
    filterFamilyName,
    inputRef,
    isLoadingFields,
    onSearchChange,
    searchString
  } = useConditionFieldSelect(filterFamily);
  const {
    onConditionSelectCancel
  } = useEditorActions();
  return /*#__PURE__*/_jsxs(EditorConditionFieldSelectPanelContainer, {
    children: [/*#__PURE__*/_jsxs(View, {
      padding: "400",
      as: "div",
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(EditorTitle, {}), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          onClick: onConditionSelectCancel
        })]
      }), /*#__PURE__*/_jsx(EditorFilterSelectBreadcrumbs, {}), /*#__PURE__*/_jsx(UIFormControl, {
        "aria-label": I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputAreaLabel'),
        className: "m-top-3",
        children: /*#__PURE__*/_jsx(UISearchInput, {
          "data-onboarding": "search-properties-input-field",
          "data-selenium-test": "fr-filter-search-input",
          inputRef: inputRef,
          onChange: onSearchChange,
          placeholder: I18n.text('newCustomerDataFilters.fieldSelectFlow.fieldSearchInputPlaceholder', {
            filterFamilyLabel: filterFamilyName.toLowerCase()
          })
        })
      })]
    }), /*#__PURE__*/_jsx(EditorConditionFieldOptions, {
      filterFamily: filterFamily,
      isLoadingFields: isLoadingFields,
      searchString: searchString
    })]
  });
};
export default EditorConditionFieldSelectPanel;